<template>
  <b-form-group class="mb-2">
    <label>{{ trans('reply_to') }}:</label>

    <b-dropdown :text="reply_to_mobile ? reply_to_mobile : trans('sms_'+reply_to_mobile_preference)" variant="link" class="reply-to-dropdown ml-2" v-if="type.indexOf('sms') >= 0 || type == 'both'">
      <b-dropdown-item v-if="organization.reply_to_mobile" @click="reply_to_mobile = organization.reply_to_mobile; reply_to_mobile_preference = 'forward_organization'; onUpdate()">
        {{ organization.reply_to_mobile }}
        <span class="badge">{{ organization.alias || organization.name }}</span>
      </b-dropdown-item>
      <b-dropdown-item v-if="user.mobile && user.mobile_confirmed" @click="reply_to_mobile = user.mobile; reply_to_mobile_preference = 'forward_sender'; onUpdate()">
        {{ user.mobile }}
        <span class="badge">{{ user.full_name }}</span>
      </b-dropdown-item>
      <b-dropdown-item @click="reply_to_mobile = null; reply_to_mobile_preference = 'auto_reply'; onUpdate()">
        {{ trans('sms_auto_reply') }}
      </b-dropdown-item>
      <b-dropdown-item @click="reply_to_mobile = null; reply_to_mobile_preference = 'do_nothing'; onUpdate()">
        {{ trans('sms_do_nothing') }}
      </b-dropdown-item>
    </b-dropdown>

    <span v-if="reply_to_emails.length == 1 && (type.indexOf('email') >= 0 || type == 'both')" class="ml-2">
      {{ reply_to_email }}
    </span>
    <b-dropdown :text="reply_to_email" variant="link" class="reply-to-dropdown ml-2" v-if="reply_to_emails.length > 1 && (type.indexOf('email') >= 0 || type == 'both')">
      <b-dropdown-item v-for="email in reply_to_emails" v-bind:key="email" :active="reply_to_email == email" @click="reply_to_email = email; onUpdate()">
        {{ email == user.email ? user.full_name : (organization.alias || organization.name) }}
        &lt;{{ email }}&gt;
      </b-dropdown-item>
    </b-dropdown>
  </b-form-group>
</template>

<script>
  export default {
    props: {
      organization: Object,
      user: Object,
      type: String,
      value: Object,
    },
    data() {
      return {
        trans: trans,
        reply_to_mobile_preference: this.value.mobile_preference,
        reply_to_mobile: this.value.mobile,
        reply_to_email: this.value.email,
      }
    },
    watch: {
      value: {
        handler() {
          this.reply_to_mobile_preference = this.value.mobile_preference
          this.reply_to_mobile = this.value.mobile
          this.reply_to_email = this.value.email
        },
        deep: true,
      }
    },
    computed: {
      reply_to_emails() {
        let emails = _.compact([this.organization.reply_to_email])
        for (let i = 0; i < this.organization.verified_from_emails.length; i++) {
          const email = this.organization.verified_from_emails[i]
          if (emails.indexOf(email) === -1) emails.push(email)
        }
        if (emails.indexOf(this.user.email) === -1) emails.push(this.user.email)
        return emails
      }
    },
    methods: {
      onUpdate() {
        this.$emit('input', {
          mobile_preference: this.reply_to_mobile_preference,
          mobile: this.reply_to_mobile,
          email: this.reply_to_email,
        })
      },
    },
    mounted() {
      window.replyToComponent = this
    }
  }
</script>